import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import CategoryPriceBox  from "../../Components/CatgeoryPriceBox";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";

export default function PaymentOptions() {
  useEffect(() => {
        sal();
      }, []);

    const handlePlanClick = () => {
      ScrollToPlans(".price-plan-section");
      };
  return (
    <>
    <Helmet>
        <title>Secure & Easy Payment Options | Online & Offline</title>
        <meta name="description" content="Buy web hosting that fits your business in easy steps. We accept all types of bank payments and offline payments too; check out this payment page to learn more." />
        <meta name="keywords" content="payment options, payment methods, payment gateways, accepted payment, online payments, secure transactions, credit card payments, digital payments, online checkout, financial transactions" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/payment-options`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/payment-options`} />
        <meta property="og:title" content="Secure & Easy Payment Options | Online & Offline" />
        <meta property="og:description" content="Buy web hosting that fits your business in easy steps. We accept all types of bank payments and offline payments too; check out this payment page to learn more." />
      </Helmet>
    <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
                <div className="col-lg-6">
                  <div className="pb-40">
                    <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Easy, Secure Payments-Your Way</span>
                    <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Payment Options</h1>
                    <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">We know that you want a reliable payment option, that’s why we offer trusted, secure, and reliable payment methods.
Our wide range of payment methods will ease your purchase with us.</p>
                  </div>
                </div>
                <div className="col-lg-6 col-xxl-6 ipad-mt">
                    <div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid fill-width-img" src="/images/aws-cloud-hosting.webp" /></div>
                </div>
            </div>
        </div>
    </section>

    <div className="simple-box-section pb-160 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Pay Easily. Launch Faster.</small>
                    <h2 className="mb-4">Our Payment Options</h2>
                    <p className="max-text-56 mb-0 fw-semibold">You can pay us with any type of debit and credit cards or E-wallets. Choose
from below payment options that suits most for you</p>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/bank-transfer.webp" /></div>
                        <h6 className="mb-4">Bank Transfer</h6>
                        <p className="mb-0">Bank: ICICI Bank Ltd</p>
                        <p className="mb-0">Branch: Vaishali Nagar, Jaipur</p>
                        <p className="mb-0">Account Name: INFINITIVE HOST TECHNOLOGIES PVT. LTD.</p>
                        <p className="mb-0">Account No. 023505501888</p>
                        <p className="mb-0">RTGS/NEFT IFSC: ICIC0000235</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/e-wallets.webp" /></div>
                        <h6 className="mb-4">E-Wallets</h6>
                        <p className="mb-0">billing@infinitivehost.com</p>
                    </div>
                  </div>
              </div>
              <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/credit-&-debit-cards.webp" /></div>
                        <h6 className="mb-4">Credit & Debit Cards</h6>
                        <p className="mb-0">Credit & Debit Cards Accepted</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <div className="pt-100 pb-100">
        <div className="pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-md-10 col-lg-8 col-xl-7 sal-animate m-auto text-center" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded m-auto"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>More Plans</small>
                        <h2 className="mb-0 text-center">
                            Take A Tour Of Our Wide Range Of Web Hosting Services.
                        </h2>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">

            
            
            
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/cloud-hosting.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Cloud Hosting
                        </h6>
                        <CategoryPriceBox category="cloud-hosting" />
                        <Link to="/cloud-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/linux-reseller.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Linux Reseller
                        </h6>
                        <CategoryPriceBox category="linux-reseller-hosting" />
                        <Link to="/linux-reseller-hosting" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/linux-vps.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Linux VPS
                        </h6>
                        <CategoryPriceBox category="managed-linux-vps" />
                        <Link to="/managed-linux-vps" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 col-xl-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="600" data-sal-easing="ease-in-out-sine">
                    <div className="price-card-item-one position-relative bg-white px-7 py-9 text-center rounded h-100">
                        <div className="mb-2">
                            <img src="/images/windows-vps.webp" alt="image" className="img-fluid"/>
                        </div>
                        <h6>
                            Windows VPS
                        </h6>
                        <CategoryPriceBox category="windows-cloud-vps" />
                        <Link to="/windows-cloud-vps" className="btn btn-dark btn-arrow btn-lg fs-14 fw-medium rounded transition mt-6 btn-height">
                            <span className="btn-arrow__text">
                                Explore Plan
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </>
  );
}
